<div class="white-box main-black">
	<!-- Filters and Export Button -->
	<div class="row py-4 mt-4 p-4 border-radius align-items-end">
		<div class="col-sm-6 col-md-3 col-lg-2" *ngIf="filters.dataMode !== dataModeValues.CURRENT_STATUS">
			<label for="period">{{"perf_analytic.period" | translate}}</label>
			<ng-select
				id="period"
				class="select"
				[items]="periods"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				(change)="onSelectionChanged({filter: 'daysFilter', value: $event.value})"
				[placeholder]="'g.durations' | translate"
				[(ngModel)]="filters.selectedPeriod"
			></ng-select>
		</div>

		<!-- voltage filter -->
		<div class="col-sm-6 col-md-3 col-lg-2">
			<label for="batteryVoltageSelect">{{"exception_reports.battery_voltages" | translate}}</label>
			<ng-select
				id="batteryVoltageSelect"
				class="select"
				[items]="batteryVoltagesOptions"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				(change)="onSelectionChanged({filter: 'daysFilter', value: $event.value})"
				[placeholder]="'qv.voltage' | translate"
				[(ngModel)]="filters.selectedBatteryVoltage"
			></ng-select>
		</div>

		<!-- capacity filter -->
		<div class="col-sm-6 col-md-3 col-lg-2">
			<label for="batteryCapacitySelect">{{"exception_reports.battery_capacities" | translate}}</label>
			<ng-select
				id="batteryCapacitySelect"
				class="select"
				[items]="batteryCapacitiesOptions"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				(change)="onSelectionChanged({filter: 'daysFilter', value: $event.value})"
				[placeholder]="'qv.capacity' | translate"
				[(ngModel)]="filters.selectedBatteryCapacity"
			></ng-select>
		</div>

		<!-- battery manufacturer filter -->
		<div class="col-sm-6 col-md-3 col-lg-2">
			<label for="batteryManufacturerSelect">{{"exception_reports.battery_manufacturer" | translate}}</label>
			<ng-select
				id="batteryManufacturerSelect"
				class="select"
				[items]="batteryManufacturerOptions"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				(change)="onSelectionChanged({filter: 'manufacturer', value: $event.value})"
				[placeholder]="'qv.battery_manufacturer' | translate"
				[(ngModel)]="filters.selectedBatteryManufacturer"
			></ng-select>
		</div>

		<!-- Vintage filter -->
		<div class="col-sm-6 col-md-3 col-lg-2">
			<label for="batteryVintageSelect">{{"devices.battery_vintage" | translate}}</label>
			<ng-select
				name="batteryVintageSelect"
				id="batteryVintageSelect"
				class="select"
				[multiple]="true"
				[items]="vintageOptionsDropdown"
				[addTag]="true"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				[placeholder]="'devices.battery_vintage' | translate"
				[(ngModel)]="filters.selectedBatteryVintage"
				(change)="onSelectionChanged({filter: 'batteryVintage', value: $event.value})"
			>
				<ng-template ng-label-tmp let-item="item" let-clear="clear">
					<span>
						<span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
						<span class="ng-value-label">{{item.label}}</span>
					</span>
				</ng-template>
			</ng-select>
		</div>

		<!-- data mode filter -->
		<!-- <div class="col-sm-6 col-md-3 col-lg-2">
			<label for="modeSelect">{{"exception_reports.data_mode" | translate}}</label>
			<ng-select
				id="modeSelect"
				class="select"
				[items]="dataModes"
				[addTag]="false"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				(change)="onSelectionChanged({filter: 'dataMode', value: $event.value})"
				[placeholder]="'exception_reports.data_mode' | translate"
				[(ngModel)]="filters.dataMode"
			></ng-select>
		</div> -->

		<!-- Export Button -->
		<div class="col-sm-6 col-md-12 col-lg-2 text-right ml-auto">
			<button class="btn btn-primary" (click)="exportReports()">{{'g.export' | translate}}</button>
		</div>
	</div>

	<!-- Battery Utilization Metrics -->
	<div class="mt-4 px-4">
		<h4 class="mb-4">{{'utilization_metrics.battery_exception_metrics' | translate}}</h4>
		
		<div class="metrics-row" *ngIf="!noData">
			<app-utilization-metric-box
				class="ml-4"
				[title]="'battery_performance.asset_utilization_performance' | translate"
				[icon]="'fa fa-line-chart'"
				(metricClicked)="commonService.scrollToWidget($event)"
				[items]="assetUtilization">
			</app-utilization-metric-box>

			<app-utilization-metric-box
				*ngIf="isLithiumOnlySite === false"
				[title]="'battery_performance.battery_maintenance' | translate"
				[icon]="'fa fa-warning'"
				[theme]="'yellow'"
				(metricClicked)="commonService.scrollToWidget($event)"
				[items]="maintenance">
			</app-utilization-metric-box>

			<app-utilization-metric-box
				*ngIf="showFastOpportunityWidget"
				class="mr-4"
				[title]="'battery_performance.opportunity_fast_charging' | translate"
				[icon]="'fa fa-bolt'"
				[theme]="'purple'"
				(metricClicked)="commonService.scrollToWidget($event)"
				[items]="charging">
			</app-utilization-metric-box>
		</div>
	</div>

	<div class="px-4 mx-4" *ngIf="!noData">
		<app-utilization-metric-box-legends
			[legendTitle]="'battery_performance.battery_utilization_legends_title' | translate"
			[showLegend]="true"
			[legend]="utilizationLegends">
		</app-utilization-metric-box-legends>
	</div>

	<div class="card-body pt-0" *ngIf="noData">
		<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
	</div>

	<app-battery-exception-widget
		id="widget-low_battery_utilization"
		[widgetConfig]="widgetsConfig.low_battery_utilization"
		[batteries]="batteries"
		[data]="utilizationData"
		[filters]="filters"
	></app-battery-exception-widget>
	<app-battery-exception-widget
		id="widget-low_battery_energy_usage"
		[widgetConfig]="widgetsConfig.low_battery_energy_usage"
		[batteries]="batteries"
		[data]="utilizationEnergyData"
		[filters]="filters"
	></app-battery-exception-widget>
	<app-battery-exception-widget
		id="widget-low_ah_percent_return"
		[widgetConfig]="widgetsConfig.low_ah_percent_return"
		[batteries]="batteries"
		[data]="lowAHData"
		[filters]="filters"
	></app-battery-exception-widget>
	<app-battery-exception-widget
		id="widget-batteries_outside_geofence"
		[widgetConfig]="widgetsConfig.batteries_outside_geofence"
		[batteries]="batteries"
		[data]="[]"
		[filters]="filters"
	></app-battery-exception-widget>
	<app-battery-exception-widget
		*ngIf="isWidgetVisible('batteries_with_low_water_level')"
		id="widget-batteries_with_low_water_level"
		[widgetConfig]="widgetsConfig.batteries_with_low_water_level"
		[batteries]="batteries"
		[data]="lowWaterLevelData"
		[filters]="filters"
	></app-battery-exception-widget>
	<app-battery-exception-widget
		*ngIf="isWidgetVisible('batteries_with_messed_equalization_charge')"
		id="widget-batteries_with_messed_equalization_charge"
		[widgetConfig]="widgetsConfig.batteries_with_messed_equalization_charge"
		[batteries]="batteries"
		[data]="messedEQData"
		[filters]="filters"
	></app-battery-exception-widget>
	<app-battery-exception-widget
		*ngIf="isWidgetVisible('potential_sulfated_batteries')"
		id="widget-potential_sulfated_batteries"
		[widgetConfig]="widgetsConfig.potential_sulfated_batteries"
		[batteries]="batteries"
		[data]="potentialSulfatedData"
		[filters]="filters"
	></app-battery-exception-widget>
	<app-battery-exception-widget
		*ngIf="isWidgetVisible('batteries_with_potential_weak_cells')"
		id="widget-batteries_with_potential_weak_cells"
		[widgetConfig]="widgetsConfig.batteries_with_potential_weak_cells"
		[batteries]="batteries"
		[data]="potentialWeakCellData"
		[filters]="filters"
	></app-battery-exception-widget>
	<app-battery-exception-widget
		*ngIf="isWidgetVisible('low_temperature_batteries')"
		id="widget-low_temperature_batteries"
		[widgetConfig]="widgetsConfig.low_temperature_batteries"
		[batteries]="batteries"
		[data]="lowTemperatureBatteriesData"
		[filters]="filters"
	></app-battery-exception-widget>
	<app-battery-exception-widget
		*ngIf="isWidgetVisible('high_temperature_batteries')"
		id="widget-high_temperature_batteries"
		[widgetConfig]="widgetsConfig.high_temperature_batteries"
		[batteries]="batteries"
		[data]="highTemperatureBatteriesData"
		[filters]="filters"
	></app-battery-exception-widget>
	<app-battery-exception-widget
		id="widget-batteries_with_low_soc"
		[widgetConfig]="widgetsConfig.batteries_with_low_soc"
		[batteries]="batteries"
		[data]="lowSOCBatteriesData"
		[filters]="filters"
	></app-battery-exception-widget>
	<app-battery-exception-widget
		id="widget-batteries_with_daily_not_plug_ins"
		[widgetConfig]="widgetsConfig.batteries_with_daily_not_plug_ins"
		[batteries]="batteries"
		[data]="notPluggedInBatteriesData"
		[filters]="filters"
	></app-battery-exception-widget>
</div>